export const usageMeterTxt = {
  DOIT_EMPLOYEE_TOOLTIP: "This reflects the customer limit",
};
